const servicePublicRoleConfig = {
  name: 'Service Public Role',
  endpoint: '/internal_admin/admin_kit/service_public_roles',
  modelKey: 'service_public_role',

  columns: [
    { name: 'service_name', title: 'Service', type: 'link' },
    { name: 'role_name', title: 'Role (Public)' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[service_name_cont]', label: 'Service' },
    { name: 'q[role_name_cont]', label: 'Role' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'service_name', label: 'Service' },
    { name: 'role_name', label: 'Role (Public)' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'service_id',
        label: 'Service',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/service_public_roles/service_search',
        displayField: 'service_name',
        required: true,
      },
      {
        name: 'role_id',
        label: 'Role (Public)',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/service_public_roles/role_search',
        displayField: 'role_name',
        required: true,
        helpMessage: 'Only public roles are shown',
      },
    ],
  },
};

export default servicePublicRoleConfig;
